/**
 * Ảnh trong suốt 1×1 base64 (PNG grayscale+alpha, alpha=0 — hoàn toàn không
 * hiển thị) — fallback cho antd `<Image>` khi ảnh sản phẩm thiếu/hỏng (URL
 * rỗng hoặc load lỗi). Tránh hiện icon "ảnh vỡ" mặc định của trình duyệt.
 * Dùng chung giữa `QRSuggestItem` (gợi ý tìm kiếm) và `OrderItemsTable` (dòng
 * thành phần combo) — cùng một khuôn xử lý, không nhân bản literal.
 *
 * LƯU Ý: pixel này không tự vẽ ra bất kỳ màu nào — nơi gọi cần placeholder
 * *nhìn thấy được* (ví dụ ô xám có viền thay vì khoảng trống) phải tự thêm
 * `backgroundColor`/`border` vào `style` của `<Image>`, hằng số này không
 * cung cấp việc đó.
 */
export const POS_IMAGE_FALLBACK =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
